import { ScheduleType } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-type.enum';
import { getLogger } from '@/logger/logger';
import { CartItem } from '@/types/cart.types';
import {
  AnalyticsScheduleType,
  STANDALONE_GUIDE_SCHEDULE_TYPE,
} from '@/types/enums/analytics/search/search-analytics.enum';
import { ProcedureTypeEnum } from '@/types/enums/procedure-type.enum';
import { isStandaloneCartItem } from '@/utils/cart/is-standalone-cart-item.util';

const logger = getLogger('cart.item-schedule-type');

const SCHEDULE_TYPES: ReadonlySet<string> = new Set(Object.values(ScheduleType));

export function isScheduleType(scheduleType: string | null | undefined): scheduleType is ScheduleType {
  return !!scheduleType && SCHEDULE_TYPES.has(scheduleType);
}

export function getCartItemScheduleType(item: CartItem): ScheduleType | AnalyticsScheduleType | undefined {
  if (isStandaloneCartItem(item)) {
    return STANDALONE_GUIDE_SCHEDULE_TYPE;
  }

  const { scheduleType } = item.slot;

  if (isScheduleType(scheduleType) && scheduleType !== ScheduleType.SCHEDULED) {
    return scheduleType;
  }

  if (item.procedure.type === ProcedureTypeEnum.LABORATORY) {
    return ScheduleType.LABORATORIAL;
  }

  if (isScheduleType(scheduleType)) {
    return scheduleType;
  }

  logger.warn('Reported a cart item without a schedule type because the API sent one the front does not know', {
    cart: { event: 'unknown_schedule_type', schedule_type: scheduleType, procedure_id: item.procedure.id },
  });

  return undefined;
}
